import React, { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Skeleton } from "@/components/ui/skeleton";

const ApprovalPending = lazy(() => import("@/pages/ApprovalPending"));

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading, approvalStatus, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="container max-w-4xl mx-auto px-4 py-16">
        <Skeleton className="h-64 w-full rounded-2xl" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admins bypass approval gate
  if (!isAdmin && approvalStatus !== "approved") {
    return (
      <Suspense fallback={null}>
        <ApprovalPending />
      </Suspense>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
